import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "@nextui-org/react";
import { apigetMonthlyData } from "../../services/apiCurrentAffairs/apicurrentaffairs";

export default function MonthlyCurrentAffairs() {
  const [loading, setLoading] = useState(true);
  const [allMonths, setAllMonths] = useState([]);
  const [filteredMonths, setFilteredMonths] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("all");
  const [selectedMonth, setSelectedMonth] = useState("all");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchMonths = async () => {
      try {
        setLoading(true);
        const res = await apigetMonthlyData();
        const data = res.data || [];

        setAllMonths(data);
        setFilteredMonths(data);

        const uniqueYears = [...new Set(data.map(item => item.monthYear.split(" ")[1]))]
          .sort((a, b) => b - a);
        setYears(uniqueYears);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchMonths();
  }, []);

  useEffect(() => {
    let filtered = allMonths;

    if (selectedYear !== "all") {
      filtered = filtered.filter(item => item.monthYear.includes(selectedYear));
    }
    if (selectedMonth !== "all") {
      filtered = filtered.filter(item => item.monthYear.startsWith(selectedMonth));
    }

    setFilteredMonths(filtered);
  }, [selectedYear, selectedMonth, allMonths]);

  const handleClick = (monthYear) => {
    navigate(`/monthly-current-affairs/${encodeURIComponent(monthYear)}`);
  };

  const resetFilters = () => {
    setSelectedYear("all");
    setSelectedMonth("all");
  };

  return (
    <div className="py-8 px-4 sm:px-6 lg:px-8 mx-auto max-w-[85rem]">
      <div className="flex flex-col gap-6 mb-10 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          {/* <Link to="/current-affairs" className="p-2 transition rounded-full hover:bg-gray-100">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </Link> */}
          <h1 className="text-3xl font-bold text-gray-800">Monthly Current Affairs</h1>
        </div>

        <div className="flex flex-wrap items-center gap-3">
            <p>Filter : </p>
          <div className="relative">
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2.5 pr-10 text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition cursor-pointer hover:border-gray-400"
            >
              <option value="all">All Years</option>
              {years.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

          <div className="relative">
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              className="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2.5 pr-10 text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition cursor-pointer hover:border-gray-400"
            >
              <option value="all">All Months</option>
              <option>January</option>
              <option>February</option>
              <option>March</option>
              <option>April</option>
              <option>May</option>
              <option>June</option>
              <option>July</option>
              <option>August</option>
              <option>September</option>
              <option>October</option>
              <option>November</option>
              <option>December</option>
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

          {(selectedYear !== "all" || selectedMonth !== "all") && (
            <button
              onClick={resetFilters}
              className="px-4 py-2.5 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Clear
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <Spinner size="lg" color="primary" />
        </div>
      ) : filteredMonths.length === 0 ? (
        <div className="py-16 text-center bg-gray-50 rounded-2xl">
          <p className="text-lg text-gray-500">
            {allMonths.length === 0
              ? "No current affairs available yet."
              : "No results found for selected filters."}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {filteredMonths.map(({ monthYear, count }) => {
            const [monthName] = monthYear.split(" ");
            return (
              <div
                key={monthYear}
                onClick={() => handleClick(monthYear)}
                className="overflow-hidden transition-all duration-300 bg-white border border-gray-200 shadow-sm cursor-pointer group rounded-2xl hover:border-blue-600 hover:shadow-xl"
              >
                <div className="p-6 text-center">
                  <div className="flex items-center justify-center w-20 h-20 mx-auto mb-4 text-2xl font-bold text-white transition-transform rounded-full shadow-lg bg-regal-yellow group-hover:scale-110">
                    {monthName.slice(0, 3).toUpperCase()}
                  </div>
                  <h3 className="text-lg font-bold text-gray-800">{monthYear}</h3>
                  <p className="mt-2 text-sm text-gray-500">
                    {count} {count === 1 ? "item" : "items"}
                  </p>
                </div>
                <div className="h-1 transition-transform origin-left scale-x-0 bg-regal-blue group-hover:scale-x-100"></div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}